export const LocalStorageEnums = {
    loginInfo: 'loginInfo',
    userInfo : 'userInfo'
};
